<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1824754" style="color: #82a339"><b>QUICK CREAM OF BROCCOLI SOUP</b></p>
<p class="ext" id="d7e1825254"><b><i>Frozen vegetables are picked and processed so quickly they often retain more nutrients than fresh ones. Many frozen vegetables are easily transformed into a satisfying soup. If broccoli is not one of your favorites, try one of the variations.</i></b></p>
<p class="h4" id="d7e1827154" style="color: #496210"><b>Prep: 5 minutes Cook: 20 minutes</b></p>
<p class="ul" id="d7e1827654">1 tablespoon butter or margarine</p>
<p class="ul" id="d7e1827954">1 medium onion, chopped</p>
<p class="ul" id="d7e1828254">1 package (10 ounces) frozen chopped broccoli</p>
<p class="ul" id="d7e1828554">1 can (14½ ounces) chicken broth or <br/> 1¾ cups Chicken Broth</p>
<p class="ul" id="d7e1830854">¼ teaspoon dried thyme</p>
<p class="ul" id="d7e1831854">⅛ teaspoon salt</p>
<p class="ul" id="d7e1832754">⅛ teaspoon ground black pepper <br/> pinch ground nutmeg <br/> pinch ground red pepper (cayenne; optional)</p>
<p class="ul" id="d7e1834354">1½ cups milk</p>
<p class="ul" id="d7e1835454">2 teaspoons fresh lemon juice</p>
<p class="pub" id="d7e1836054" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In 3-quart saucepan, melt butter over medium heat. Add onion and cook, stirring occasionally, until tender, about 5 minutes. Add frozen broccoli, broth, thyme, salt, pepper, nutmeg, and ground red pepper, if using; heat to boiling over high heat. Reduce heat and simmer 10 minutes.</p>
<p class="pub" id="d7e1838354"><span style="color: #c15b49"><b>2.</b></span> Spoon half of mixture into blender; cover, with center part of cover removed to let steam escape, and puree until smooth. Pour into bowl. Repeat with remaining mixture.</p>
<p class="pub" id="d7e1840254"><span style="color: #c15b49"><b>3.</b></span> Return puree to saucepan; stir in milk. Heat through, stirring often (do not boil). Remove from heat and stir in lemon juice. Makes about 3¾ cups or 4 first-course servings.</p>
<p class="ntx" id="d7e1843054">Each serving: About 130 calories, 6g protein, 12g carbohydrate, 7g total fat (4g saturated), 21mg cholesterol, 594mg sodium.</p>
<p class="h4l" id="d7e1845754" style="color: #496210"><b>QUICK CREAM OF CORN SOUP</b></p>
<p class="tx1" id="d7e1846254">Prepare as directed above but substitute <b>1 package (10 ounces) frozen whole-kernel corn</b> for broccoli; if you like, add <b>¾ teaspoon chili powder</b> after cooking onion and cook 30 seconds before adding broth.</p>
<p class="h4l" id="d7e1849354" style="color: #496210"><b>QUICK CREAM OF PEA SOUP</b></p>
<p class="tx1" id="d7e1849854">Prepare as directed but substitute <b>1 package (10 ounces) frozen peas</b> for broccoli; if you like, add <b>¼ teaspoon dried mint leaves</b> with broth.</p>
<p class="h4l" id="d7e1852854" style="color: #496210"><b>QUICK CREAM OF ASPARAGUS SOUP</b></p>
<p class="tx1" id="d7e1853454">Prepare as directed but substitute <b>1 package (10 ounces) frozen asparagus</b> for broccoli; if you like, add <b>¼ teaspoon dried tarragon</b> with broth.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c49_r1.vue?1da7fe4a